import apiClient from "../lib/api-client";
import type { Invoice, InvoiceItem } from "@medicorepay/shared/types";

// Re-export types for backward compatibility
export type { Invoice, InvoiceItem };

export interface InvoiceStats {
  todaySales: number;
  todayInvoiceCount: number;
  totalInvoices: number;
  pendingPaymentAmount: number;
  pendingPaymentCount: number;
}

export const invoiceService = {
  async getInvoices(params?: {
    page?: number;
    limit?: number;
    storeId?: string;
    customerId?: string;
    status?: string;
    paymentStatus?: string;
    dateFrom?: string;
    dateTo?: string;
  }): Promise<{ data: Invoice[]; total: number; page: number; limit: number }> {
    const response = await apiClient.get("/invoices", { params });
    return response.data;
  },

  async getInvoice(id: string): Promise<Invoice> {
    const response = await apiClient.get(`/invoices/${id}`);
    return response.data;
  },

  async getInvoiceStats(storeId?: string): Promise<InvoiceStats> {
    const response = await apiClient.get("/invoices/stats", {
      params: { storeId },
    });
    return response.data;
  },

  async getDailySales(
    days: number = 7,
    storeId?: string,
  ): Promise<Array<{ date: string; total: number }>> {
    const response = await apiClient.get("/invoices/daily-sales", {
      params: { days, storeId },
    });
    return response.data;
  },
};
